import { StyledEditCardContainer } from '../components/Filters.components';
import { PostChecker } from '../components/PostChecker';
import { Fragment } from 'react/jsx-runtime';
import { EditExperienceHeader } from '../components/EditExperienceHeader';
import { EditExperienceBody } from '../components/EditExperienceBody';
import { EditExperienceTable } from '../components/EditExperienceTable';

export const EditExperience = () => {
  return (
    <Fragment>
      <PostChecker />
      <StyledEditCardContainer>
        <EditExperienceHeader />
        <EditExperienceBody />
        <EditExperienceTable />
      </StyledEditCardContainer>
    </Fragment>
  );
};
